import { render, staticRenderFns } from "./WidgetNode.vue?vue&type=template&id=8ce32932&scoped=true"
import script from "./WidgetNode.vue?vue&type=script&lang=js"
export * from "./WidgetNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce32932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ce32932')) {
      api.createRecord('8ce32932', component.options)
    } else {
      api.reload('8ce32932', component.options)
    }
    module.hot.accept("./WidgetNode.vue?vue&type=template&id=8ce32932&scoped=true", function () {
      api.rerender('8ce32932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/WidgetNode.vue"
export default component.exports